import { render, staticRenderFns } from "./AnnonceForm.vue?vue&type=template&id=2a56f9cb&scoped=true"
import script from "./AnnonceForm.vue?vue&type=script&lang=js"
export * from "./AnnonceForm.vue?vue&type=script&lang=js"
import style0 from "./AnnonceForm.vue?vue&type=style&index=0&id=2a56f9cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a56f9cb",
  null
  
)

export default component.exports